// Approve or deny a request under the address it was opened to
// (02-escalation-and-grants.md § the approver): `addressOf(record)`.

import type { Bus } from "../../platform/bus.ts";
import {
  escalationSubject,
  SERVICE,
  type Decision,
  type ResolveReply,
  type ResolveRequest,
} from "../../wire/guard.ts";

/** resolveUnder resolves the escalation id, addressed to approver, with decision. */
export function resolveUnder(
  bus: Bus,
  approver: string,
  id: string,
  decision: Decision,
): Promise<ResolveReply> {
  return bus.call<ResolveReply>(SERVICE, escalationSubject(approver, "resolve", id), {
    decision,
  } satisfies ResolveRequest);
}
